import Button from "@mui/material/Button";
import React from "react";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export const OriginalCalendarURI = "/where-to-dance/pro-calendar"
export const OriginalCalendarButton = (props) => <Button {...props} variant={"contained"} size={"small"} color={"warning"} startIcon={<CalendarMonthIcon size={"small"} />} href={OriginalCalendarURI}><span style={{fontSize: "80%"}}>Pro Calendar</span></Button>